export const SET_MENU = 'SET_MENU'
export const SET_MENU_ITEMS = 'SET_MENU_ITEMS'
export const SET_MENU_SELECTED_ITEMS = 'SET_MENU_SELECTED_ITEMS'
export const SET_MENU_SELECTED_LEVEL = 'SET_MENU_SELECTED_LEVEL'
export const SET_MENU_ACTIVE_ITEM = 'SET_MENU_ACTIVE_ITEM'
export const SET_MENU_ACTIVE_ID = 'SET_MENU_ACTIVE_ID'
export const SET_DRAWER_OPEN = 'SET_DRAWER_OPEN'